import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { IPurchaseInvoiceReportGetAllParams } from "@api/stores/purchaseInvoiceReport/types";
import type { IFileResponse } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  IPurchaseInvoiceReportGetAllParams
>("stores.purchaseInvoiceReport.exportExcel");

export const exportExcel = {
  ...getApis,
};
